import Enums from "../../../../../utils/Enums";

const GOSBenefits = {
  headers: [
    {
      title: ``,
      mandatory: true,
      attributes: {
        style: {
          width: 10
        }
      }
    },
    {
      title: `Benefits / Plan Type`,
      mandatory: true,
      attributes: {
        style: {
          width: "30%"
        }
      }
    },
    {
      title: `Plan 1`,
      tier: 1
    },
    {
      title: `Plan 2`,
      tier: 2
    },
    {
      title: `Plan 3`,
      tier: 3
    },
    {
      title: `Plan 4`,
      tier: 4
    }
  ],
  rows: [
    {
      id: 1,
      columns: [
        {
          data: `<strong>a</strong>`
        },
        {
          data: `<strong>Specialist Consultation at Singapore Govt Restructured Hospital (GRH)</strong>`,
          info: `<em>(recommended by a Registered Medical Practitioner)</em>`
        },
        {
          data: `S$ 2,000 per policy year`
        },
        {
          data: `S$ 1,500 per policy year`
        },
        {
          data: `S$ 1,000 per policy year`
        },
        {
          data: `Overall policy year limit of S$ 500`,
          attributes: {
            rowspan: 4
          },
          style: {
            width: "100%",
            textAlign: "center"
          }
        }
      ]
    },
    {
      id: 2,
      columns: [
        {
          data: `<strong>b</strong>`
        },
        {
          data: `<strong>Specialist Consultation at Private Hospital (PTE)</strong>`,
          info: `<em>(recommended by a Registered Medical Practitioner)</em>`
        },
        {
          data: `S$ 800 per policy year`
        },
        {
          data: `S$ 400 per policy year`
        },
        {
          data: `S$ 200 per policy year`,
          attributes: {
            notLast: true
          }
        }
      ]
    },
    {
      id: 2,
      columns: [
        {
          data: `<strong>c</strong>`
        },
        {
          data: `<strong>All other Diagnostic X-Ray and Lab Test</strong>`,
          info: `<em>(GP or SP referral required)</em>`
        },
        {
          data: `S$ 800 per policy year`
        },
        {
          data: `S$ 400 per policy year`
        },
        {
          data: `S$ 200 per policy year`,
          attributes: {
            notLast: true
          }
        }
      ]
    },
    {
      id: 3,
      columns: [
        {
          data: `<strong>d</strong>`
        },
        {
          data: `<strong>Psychiatric treatment</strong>`,
          info: `<em>(with referral)</em>`
        },
        {
          data: `S$ 500 per policy year`
        },
        {
          data: `S$ 500 per policy year`
        },
        {
          data: `S$ 500 per policy year`,
          attributes: {
            notLast: true
          }
        }
      ]
    }
  ],
  footnotes: []
};

let GOSPremium = {
  headers: [
    {
      title: `Age Last Birthday`,
      mandatory: true
    },
    {
      title: `Plan 1`,
      tier: 1
    },
    {
      title: `Plan 2`,
      tier: 2
    },
    {
      title: `Plan 3`,
      tier: 3
    },
    {
      title: `Plan 4`,
      tier: 4
    }
  ],
  rows: [
    {
      id: 1,
      columns: [
        {
          data: `<strong>16-74</strong>`
        },
        {
          data: `S$ 232.13`
        },
        {
          data: `S$ 194.43`
        },
        {
          data: `S$ 177.11`
        },
        {
          data: `S$ 138.41`
        }
      ]
    }
  ],
  footnotes: []
};

//   ----------------------------------------------------------------------
const PSIH = {
  id: 14,
  code: "PSIH",
  label: `Group Outpatient Specialist (GOSP)`,
  types: [
    {
      id: 1,
      order: 1,
      type: Enums.PLANS_TYPE.BENEFITS,
      label: "Plans by Benefits",
      data: [GOSBenefits]
    },
    {
      id: 2,
      order: 2,
      type: Enums.PLANS_TYPE.PREMIUMS,
      label: "Plans by Premium (inclusive of 9% GST)",
      data: [GOSPremium]
    }
  ]
};

export default PSIH;
